const MiniLoader = () => {
    return (
        <div className="mini-custom-loader my-3"></div>
    )
}

export default MiniLoader;